<pr-form
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  <h3 class="drawer-title">Informations</h3>

  <div class="form-sct-container">
    <input formControlName="id" type="hidden" />

    <pr-input label="Membre du foyer" [derrors]="derrors">
      <mat-select formControlName="userId">
        @for (user of users; track user) {
          <mat-option [value]="user.id">
            {{
              (user.firstName
                ? user.firstName
                : user.gender === 'F'
                  ? 'Madame'
                  : 'Monsieur') +
                ' ' +
                user.lastName
            }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <pr-input [label]="label" [derrors]="derrors">
      <input formControlName="label" type="text" />
    </pr-input>

    @if (['SALARY', 'BIC', 'BNC', 'BA'].includes(type)) {
      <pr-input label="Nom de l'entreprise" [derrors]="derrors">
        <input formControlName="companyName" type="text" />
      </pr-input>
    }

    @if (['SALARY', 'BIC', 'BNC', 'BA', 'RETIREMENT'].includes(type)) {
      <pr-input label="Groupe socioprofessionnel" [derrors]="derrors">
        <mat-select
          formControlName="groupe"
          (valueChange)="updateGroupe($event)"
        >
          @for (groupe of groupes; track groupe) {
            <mat-option [value]="groupe.groupe">
              {{ groupe.label }}
            </mat-option>
          }
        </mat-select>
      </pr-input>
    }

    @if (['SALARY', 'BIC', 'BNC', 'BA', 'RETIREMENT'].includes(type)) {
      <pr-input label="Catégorie sociopro." [derrors]="derrors">
        <mat-select
          formControlName="categorie"
          (valueChange)="updateCategorie($event)"
        >
          @for (categorie of categories; track categorie) {
            <mat-option [value]="categorie.categorie">
              {{ categorie.label }}
            </mat-option>
          }
        </mat-select>
      </pr-input>
    }

    @if (['SALARY', 'BIC', 'BNC', 'BA', 'RETIREMENT'].includes(type)) {
      <pr-input label="Secteur d'activité" [derrors]="derrors">
        <mat-select formControlName="activitySector">
          <mat-option>Aucun</mat-option>
          @for (
            companyActivitySector of companyActivitySectors;
            track companyActivitySector
          ) {
            <mat-option [value]="companyActivitySector.id">
              {{ companyActivitySector.value }}
            </mat-option>
          }
        </mat-select>
      </pr-input>
    }

    @if (['SALARY'].includes(type)) {
      <pr-input-radio
        formControlName="workInPublic"
        label="Travail dans le secteur public"
        toggleBgEmpty="true"
      >
      </pr-input-radio>
    }
  </div>

  <h3 class="drawer-title">Évolution du revenu</h3>

  <div class="form-sct-container">
    <ul formArrayName="earnings">
      @for (earning of earnings.controls; track earning; let i = $index) {
        <pr-form-list-item
          [showReturnChevron]="false"
          clazz="form-align-end"
          headerClass="horizontal-title-list-item"
          [formGroupName]="i"
          [index]="i"
          [derrors]="derrors"
          (onDelete)="removeEarning($event)"
          buttonStyle="label"
          buttonClass="btn-nostyle neutral btn-list-remove"
          buttonIconVbWidth="23"
          buttonIconVbHeight="23"
          itemName="ce revenu"
        >
          @if (earning.controls.amount.value) {
            <div class="pr-form-list-title-primary">
              {{
                earning.controls.amount.value
                  | currency: 'EUR' : 'symbol' : '.0-0'
              }}
            </div>
            @if (
              earning.controls.startDate.value &&
              earning.controls.startDate.status === 'VALID'
            ) {
              <div class="pr-form-list-title-secondary">
                du {{ earning.controls.startDate.value | date: 'shortDate' }}
                @if (earning.controls.endDate.value) {
                  au {{ earning.controls.endDate.value | date: 'shortDate' }}
                }
                @if (!earning.controls.endDate.value) {
                  à aujourd'hui
                }
              </div>
            }
          } @else {
            <div class="pr-form-list-title-primary">Nouveau montant</div>
          }
          <ea-earning-form
            item
            [form]="earning"
            [entity]="entity.earnings[i]"
            [derrors]="derrors"
          ></ea-earning-form>
        </pr-form-list-item>
      }
      @if (derrors && form.controls.earnings.errors) {
        <ul class="pr-form-list-errors">
          @if (form.controls.earnings.errors) {
            <li>Vous devez declarer au moins un montant</li>
          }
        </ul>
      }
      <div class="pr-form-list-add">
        <pr-button
          clazz="btn-list-add neutral"
          rightIcon="sp-plus"
          label="Ajouter un nouveau revenu"
          (onClick)="addEarning()"
        ></pr-button>
      </div>
    </ul>
    <div class="form-align-end">
      @if (entity && entity.id) {
        <pr-button-confirm
          clazz="btn-nostyle neutral btn-list-remove"
          displayConfirm="danger"
          modalIcon="delete_outline"
          leftIcon="sp-trash"
          iconViewBoxWidth="23"
          iconViewBoxHeight="23"
          (onConfirm)="deleteProfession()"
          label="Supprimer le revenu"
          comment="Toute suppression est definitive, les données seront perdues."
          labelConfirm="Supprimer"
          labelCancel="Annuler"
        >
          Êtes-vous sûr(e) de vouloir supprimer
          <em class="text-red"> {{ removeType }} </em> ?
        </pr-button-confirm>
      }
    </div>
  </div>
</pr-form>
